export default __webpack_public_path__ + "assets/62489b.svg";